import update from 'immutability-helper';

import applyTicketTypeSelection from '../lib/applyTicketTypeSelection';
import useCheckoutState from './useCheckoutState';

export default function useCheckoutTicketFormHelpers() {
  const { setForm, hasFocusedCheckoutRef, page, checkout } = useCheckoutState();
  const pageTicketGroups = (page ?? checkout)?.ticketGroups;

  function setTicketType(ticketGroupId, ticketTypeId, quantity = 1, options) {
    hasFocusedCheckoutRef.current = true;

    setForm(form =>
      applyTicketTypeSelection(form, ticketGroupId, ticketTypeId, quantity, {
        ...options,
        pageTicketGroups,
      }),
    );
  }

  function unsetTicketType(ticketGroupId, ticketTypeId) {
    hasFocusedCheckoutRef.current = true;

    // Quantity 0 also clears the entry's typed pwyw amount (see
    // applyTicketTypeSelection).
    setForm(form =>
      applyTicketTypeSelection(form, ticketGroupId, ticketTypeId, 0, { pageTicketGroups }),
    );
  }

  function setTicketTypePayWhatYouWantAmount(ticketGroupId, ticketTypeId, amount) {
    hasFocusedCheckoutRef.current = true;

    // Single-pass upsert. Only the PWYW amount is set — quantity is managed
    // by the quantity select / selection handlers.
    setForm(form => {
      const entries = form.ticketGroups[ticketGroupId] || [];
      const exists = entries.some(t => t.ticketTypeId === ticketTypeId);

      const nextEntries = exists
        ? entries.map(t =>
            t.ticketTypeId === ticketTypeId ? { ...t, payWhatYouWantAmount: amount } : t,
          )
        : [...entries, { ticketTypeId, quantity: 0, payWhatYouWantAmount: amount }];

      return update(form, {
        ticketGroups: { [ticketGroupId]: { $set: nextEntries } },
      });
    });
  }

  return { setTicketType, unsetTicketType, setTicketTypePayWhatYouWantAmount };
}
